import { useState } from "react";
import { Search, Star } from "lucide-react";

const statusStyles = {
  Completed: "bg-gray-100 text-gray-600",
  Cancelled: "bg-red-100 text-red-600",
};

export default function OrderHistoryTable({ data }) {
  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("All statuses");

  const filtered = data.filter((row) => {
    const matchesQuery = row.name.toLowerCase().includes(query.toLowerCase());
    const matchesStatus = statusFilter === "All statuses" || row.status === statusFilter;
    return matchesQuery && matchesStatus;
  });

  return (
    <div>
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-4 py-2.5 flex-1 min-w-[220px]">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search mentor or course..."
            className="w-full text-sm focus:outline-none"
          />
        </div>
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="border border-gray-200 rounded-xl px-4 py-2.5 text-sm text-gray-700 focus:outline-none"
        >
          <option>All statuses</option>
          <option>Completed</option>
          <option>Cancelled</option>
        </select>
      </div>

      <div className="bg-white border border-gray-100 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
              <th className="px-6 py-4">MENTOR / COURSE</th>
              <th className="px-6 py-4">DATE & TIME</th>
              <th className="px-6 py-4">PRICE</th>
              <th className="px-6 py-4">MY RATING</th>
              <th className="px-6 py-4">STATUS</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((row) => (
              <tr key={row.id} className="border-b border-gray-50 last:border-none">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center shrink-0">
                      {row.initials}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">{row.name}</p>
                      <p className="text-xs text-gray-500">{row.specialty}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <p className="text-gray-900">{row.date}</p>
                  <p className="text-xs text-gray-500">{row.time}</p>
                </td>
                <td className="px-6 py-4 font-semibold text-indigo-600">
                  ₹{row.price.toLocaleString("en-IN")}
                </td>
                <td className="px-6 py-4">
                  {row.rating ? (
                    <span className="flex items-center gap-1 text-gray-900">
                      <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" /> {row.rating}
                    </span>
                  ) : (
                    <span className="text-gray-400">—</span>
                  )}
                </td>
                <td className="px-6 py-4">
                  <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${statusStyles[row.status]}`}>
                    {row.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}